import { toast } from "react-toastify";
import { SERVER_URL } from "../../config/config";

export const makeApiRequest = async (url, method, headers, body) => {
    let response;
    try {
        if (body) {
            response = await fetch(url, {
                method,
                headers,
                body: body instanceof FormData ? body : JSON.stringify(body)
            })
        } else {
            response = await fetch(url, {
                method,
                headers,
            });
        }

        toast.dismiss()
        if(url === `${SERVER_URL}/api/refresh/` && (response.status === 403 || response.status === 401 || response.status === 500)){
            return {"message" : "Log user out"}
        }

        if (response.ok) {
            return await response.json();
            
        }else if (response.status === 401 || response.status === 403 ) {
            const errorData = await response.json();
            if(method === "POST" || method === "PUT"
            || method === "PATCH" || method === "DELETE"){
                toast.error(errorData?.message
                             || errorData?.error?.message
                             || 'Ooops, something went wrong! Try again.')
            }
            return {"message": "UnAuthorized Token"}
        }else if(response.status === 500){
            // console.log(await response.json())
            toast.error("Server Error!")
        }else {
            const errorData = await response.json();
            // console.log("errorData", errorData)
            toast.error(errorData?.message || errorData?.error?.message || 'Ooops, something went wrong! Try again.')
            return null
        }
    } catch (error) {
        toast.dismiss()
        // console.error("API request error:", error);
        // throw error;
    }
};
